import { FC } from "react";
import { Typography } from "antd";

const UserMetricsTab: FC = () => {
    return (
        <div>
            <Typography.Title level={4}>User Metrics</Typography.Title>
            <Typography.Text>Charts and stats about user activity go here.</Typography.Text>
        </div>
    );
};

export default UserMetricsTab;
